<nz-skeleton
  [ngClass]="loading ? 'mt-4' : 'mt-0'"
  [nzLoading]="loading"
  [nzActive]="true"
>
  <div class="mt-4">
    <span><b>Shipping Information</b></span>
    <div
      class="p-3 mt-2"
      style="border: 1px solid; border-color: grey; border-radius: 5px"
    >
      <div class="d-flex justify-content-between">
        <div class="d-flex justify-content-end">
          <img
            src="https://storage.googleapis.com/komerce/assets/icons/profile-placehold.svg"
            alt=""
            width="40px"
          />
          <div class="ml-4" style="margin-left: 15px">
            <span>
              <b>{{ detailOrder?.receiver_name || "-" }}</b> <br />
              {{ detailOrder?.receiver_phone || "-" }}
            </span>
          </div>
        </div>
        <div class="d-flex justify-content-end">
          <button
            class="btn btn-outline-primary"
            (click)="onTrackReceipt()"
          >
            Track Receipt
          </button>
        </div>
      </div>
      <div class="d-flex mt-4 justify-content-between">
        <div class="d-flex justify-content-start">
          <div class="">
            <p>Expedition</p>
            <p>Receipt Number</p>
            <p>Address Detail</p>
          </div>
          <div class="ml-4" style="margin-left: 20px">
            <span class="d-flex align-items-center">
              :
              <img
                [src]="detailOrder?.shipping_logo"
                [alt]="detailOrder?.shipping"
                style="max-width: 50px"
              />
              <span class="mx-2">{{
                handleType(detailOrder?.shipping_type || "")
              }}</span>
            </span>
            <p></p>
            <p>: {{ detailOrder?.awb || "-" }}</p>
            <p>: {{ detailOrder?.receiver_address || "-" }}</p>
          </div>
        </div>
        <div class="d-flex justify-content-end">
          <div class="d-flex align-items-end">
            <p>
              Shipping by
              <img
                src="https://storage.googleapis.com/komerce/assets/logo/Komship-by-komerce.svg"
                alt=""
                width="80px"
              />
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</nz-skeleton>
